import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InsightAggregationData, MotivationFullDetails, ScoreDetails, UserMotivationDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { SendFeedbackComponent } from 'src/app/moov-common/components/send-feedback/send-feedback/send-feedback.component';
import { MotivationPartialViewComponent } from 'src/app/moov-common/components/motivation-partial-view/motivation-partial-view/motivation-partial-view.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { QuickActionSelection } from 'src/app/moov-common/components/quick-actions/quick-actions/quick-actions.component';
import { ClaroEvents } from 'src/app/moov-common/services/google-analytics/analytics.enum';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { AccountTypeEnum, CareerProcessTypeEnum, UserCVMetadata } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { ClaroAlertTypeEnum } from 'src/app/moov-common/components/claro-alert/claro-alert.component';
import { StructuredProcessStateService } from 'src/app/moov-common/services/chat/structured-process-state.service';
import { StepTypeEnum, StructuredProcessData, StructuredProcessInstance, StructuredProcessInstanceStatusEnum } from 'src/app/moov-common/services/chat/strcutredProcess-data';

@Component({
  selector: 'app-my-motivations',
  templateUrl: './my-motivations.component.html',
  styleUrls: ['./my-motivations.component.scss']
})
export class MyMotivationsComponent extends BaseComponent implements OnInit {
  userFirstName: string;
  myMotivations: UserMotivationDetails[];
  motivationsImageRootFolder = 'assets/motivations/';
  imageCommonFolder = 'assets/common/';
  insightsRetreived = false;
  insights : InsightAggregationData[];
  inightsChips : string[];
  isReportGenerated : boolean = false;
  userNewToResults : boolean = false;
  isDataNotUpdatedWarning: boolean = false;
  moovWizardOpened: boolean = false;
  makeMoovWizardSelectedIssue : string = "";
  makeMoovWizardSelectedMotivation : string = "";
  presentMoovsForSelf : boolean = false;
  isLimitedView : boolean = false;
  selectedCVFile: File | null = null;
  cvUploadSuccessFull : boolean = false;
  isMemberInCareerProcess : boolean = false;
  isB2CUser : boolean = false;
  scoreDetails: ScoreDetails | null = null;
  userCVMetadata: UserCVMetadata | null = null;
  isCVDataUploaded : boolean = false;
  isCVDataUploading : boolean = false;
  isLoadingCVMetadata : boolean = false;
  alertTypeEnum = ClaroAlertTypeEnum;
  nextStepId: string = '';
  nextStepHeader: string = '';
  isDiscoveryStepCompleted: boolean = false;

  @ViewChild('cvFileInput') cvFileInput!: ElementRef<HTMLInputElement>;


  constructor(private readonly personalUserDataService: AbstractPersonalUserDataService, 
              public readonly motivationsService: AbstractMotivationsService,
              public translate: TranslateService,
              public dialog: MatDialog,
              private router: Router,
              private utils: UtilsService,
              private processStateService: StructuredProcessStateService) {
    super();
    this.myMotivations = [];
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.insightsRetreived = false;

    this.getUserDetails();
    this.getUserMotivations();
    this.getUserInsights();
    this.estimateDiscoveryDate();
    this.verifyMoovsForSelf();
    this.verifyIsLimitedView();
    this.getUserCVMetadata();
    this.findNextProcessStep();
  }

  ngAfterViewInit() {
    this.analytics.myMotivationsPage();
  }

  getUserDetails(): void {
    // console.log(`this.user is ${JSON.stringify(this.user)}`);
    
    if (this.user?.accountType === AccountTypeEnum.CAREER_INDEPENDENT || this.user?.accountType === AccountTypeEnum.CAREER_INDEPENDENT_US){
      this.isB2CUser = true;
    }

    if (this.user?.careerProcessType == CareerProcessTypeEnum.INDEVIDUAL_CONSULTANT_LEAD
        && !this.isB2CUser){
      this.isMemberInCareerProcess = true;
    }

    this.motivationsService.getScoreForUser(this.user!.id).subscribe(scoreDetails => {
      this.scoreDetails = {...scoreDetails, score: (this.user!.currTotalEnergy * 10)};
      
      // this.scoreDetails = {...scoreDetails, score: 0};
    })
  }

    getUserMotivations():void{
    if (!this.user){
      return;
    }
    // console.log(`in getUserMotivations, user details are ${JSON.stringify(this.user)}`);

    this.motivationsService.getMotivationsForUser(this.user.id).subscribe((motivationsDetails :UserMotivationDetails[]) => {
      this.myMotivations = motivationsDetails.sort((motivation1, motivation2) => {
        if (motivation1.gapFactor! < motivation2.gapFactor!){
          return 1;
        }
        else if (motivation1.gapFactor! > motivation2.gapFactor!){
          return -1;
        }
        else{
          return 0;
        }
      });

      let temp_isDataNotUpdatedWarning = false;
      
      for (let currMotivation of this.myMotivations){
        if (!currMotivation.isGapDataRelevant){
          temp_isDataNotUpdatedWarning = true;
        }
      }
      this.isDataNotUpdatedWarning = temp_isDataNotUpdatedWarning;
    });
  }

  getMotivaitonColor (motivationId: string): string{
    return this.motivationsService.getMotivationColor(motivationId);
  }

  verifyIsLimitedView(): void{
    if (this.user?.accountType == AccountTypeEnum.CLARO_DISCOVERY){
      this.isLimitedView = true;
    }
  }

  openMotivation(motivationId:string): void{
    this.dialog.open(MotivationPartialViewComponent, {
      height: '500px',
      width: '600px',
      data: {selectedMotivationId:motivationId, isRTL:this.isRTL, isSelf:true}
    });
  }

  getUserInsights(): void{
    this.motivationsService.insightsForSelf().subscribe(userInsights => {
      this.insights = userInsights;
      this.inightsChips = this.insights.map(insightType => insightType.insightType.name)
      this.insightsRetreived = true;
      // console.log(`insights retrieved chips are ${JSON.stringify(this.inightsChips)}`);
    });
  }

  sendFeedback(): void{
    this.dialog.open(SendFeedbackComponent, {
      height: 'fit-content',
      width: (this.isMobileView? '90%':'40%'),
      data: {}
    });
  }

  getMotivationIconName(motivationId:string): string{
    return this.motivationsService.getMotivationIconName(motivationId);
  }

  getUserInsightsReport(): void{
    this.isReportGenerated = true;
    this.personalUserDataService.getUserInsightsReport().subscribe(data => {

      console.log('in MM getUserInsightsReport', data);
      let blob = new Blob([data as BlobPart], {type: 'application/pdf'});

      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "FullReport.pdf";
      this.isReportGenerated = false;
      link.click();
    });
  }

  makeDirectMoov(selectedAction: QuickActionSelection) {
    this.makeMoovWizardSelectedIssue = selectedAction.actionId;
    this.makeMoovWizardSelectedMotivation = selectedAction.motivationId;
    this.analytics.sendClaroEvent(ClaroEvents.MoovToSelf, {'IssueId' : this.makeMoovWizardSelectedIssue})
    
    this.moovWizardOpened = true;
  }

  challengeResults(): void{
    this.router.navigate([NAVIGATION_ROUTES.app.dicovery]);

  }

  verifyMoovsForSelf(): void{
    this.personalUserDataService.verifyFeature(FeatureID.moovsForSelf).subscribe(res => {
      this.presentMoovsForSelf = res;
    });
  }

  estimateDiscoveryDate(): void{
    this.personalUserDataService.getDiscoveryProcessEndDate().subscribe(resDate => {
      const daysFromDiscovery = this.utils.daysBetween(new Date(resDate.date), new Date());

      if ( daysFromDiscovery < 14 && this.user?.accountType !== AccountTypeEnum.CAREER_INDEPENDENT && this.user?.accountType !== AccountTypeEnum.CAREER_INDEPENDENT_US){
        this.userNewToResults = true;
      }
    });
  }
  
  openSelectCVFileSeletionDialog(): void{
    this.cvFileInput.nativeElement.click();
  }

  uploadCV(event: Event): void{
    this.cvUploadSuccessFull = false;

    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file: File = input.files[0];

      // Validate that the file is a PDF
      if (file.type !== 'application/pdf') {
        console.error('Selected file is not a PDF.');
        return;
      }

      this.isCVDataUploading = true;
      this.personalUserDataService.uploadCV(file).subscribe(res=>{
        // console.log('uploadCV successfull');
        this.cvUploadSuccessFull = true;
        this.isCVDataUploading = false;
        this.analytics.sendClaroEvent(ClaroEvents.UserUploadedCV);
        console.log('uploadCV successfull, waiting 20 seconds to get CV metadata');
        setTimeout(() => {
          this.getUserCVMetadata();
        }, 20000);
      });
    }
  }

  closeMakeMoovWizard(): void{
    this.refreshMoovs();
    this.moovWizardOpened = false;
  }

  refreshMoovs(): void{
    
  }

  findNextProcessStep(): void {
    if (!this.isB2CUser) return;
    this.processStateService.processData$.subscribe((data: StructuredProcessData | null) => {
      if (!data?.stages?.length) return;
      const allSteps = data.stages.flatMap(s => s.steps);
      const introStep = allSteps.find(s => s.stepType === StepTypeEnum.INTRO_CONSENT);
      const introIdx = allSteps.findIndex(s => s.stepType === StepTypeEnum.INTRO_CONSENT);
      if (introStep && introIdx < allSteps.length - 1) {
        const nextStep = allSteps[introIdx + 1];
        this.nextStepId = nextStep.id;
        this.nextStepHeader = nextStep.header;
      }
    });

    this.processStateService.processInstance$.subscribe((instance: StructuredProcessInstance | null) => {
      if (!instance?.stagesInstances?.length) return;
      for (const stage of instance.stagesInstances) {
        const stepInstance = stage.stepsInstances.find(si =>
          this.isIntroConsentStep(si.stepId)
        );
        if (stepInstance) {
          this.isDiscoveryStepCompleted = stepInstance.status === StructuredProcessInstanceStatusEnum.COMPLETED;
          return;
        }
      }
    });
  }

  private isIntroConsentStep(stepId: string): boolean {
    const data = this.processStateService.processData$.value;
    if (!data?.stages?.length) return false;
    const allSteps = data.stages.flatMap(s => s.steps);
    const step = allSteps.find(s => s.id === stepId);
    return step?.stepType === StepTypeEnum.INTRO_CONSENT;
  }

  continueToNextStep(): void {
    this.processStateService.pendingStepId = this.nextStepId;
    this.router.navigate(['/process']);
  }

  getUserCVMetadata(): void{
    console.log('getUserCVMetadata');
    this.isLoadingCVMetadata = true;
    this.personalUserDataService.getUserCVMetadata().subscribe(res => {
      if (res){
        this.userCVMetadata = res;
        this.isCVDataUploaded = res.isAnalyzed;
      }
      else{
        this.userCVMetadata = null;
        this.isCVDataUploaded = false;
      }
      this.isLoadingCVMetadata = false;
    });
  }
}
